/**
 * ヘッダーのコントロール
 */
export default function headerControll() {
  (function ($) {
    var startPos = 0, winScrollTop = 0;

    // 上スクロール時に表示
    $(window).on('scroll', function() {
      winScrollTop = $(this).scrollTop();

      if (winScrollTop >= startPos && winScrollTop > 100) {
        $('.l-site-header').addClass('js-is-hide');

        if (winScrollTop > 100) {
          $('.l-site-header').addClass('js-is-overlapping');
        } else {
          $('.l-site-header').removeClass('js-is-overlapping');
        }
      } else {
        $('.l-site-header').removeClass('js-is-hide');

        if (winScrollTop > 100) {
          $('.l-site-header').addClass('js-is-overlapping');
        } else {
          $('.l-site-header').removeClass('js-is-overlapping');
        }
      }
      startPos = winScrollTop;
    });

    // ヘッダーの高さを設定

  })(jQuery);
}
